<div class="row" style="margin-top: -0.5rem">
  <div class="col-12 d-flex">
    <div class="card flex-fill border-0 bg-white shadow-lg">
      <div class="card-body pt-2 pb-2">
        <h4 class="mb-2 font-bold">Dados Meteorológicos</h4>

        <!-- Mensagem de alerta -->
        <app-alert [alert]="alert" (close)="closeAlert()"></app-alert>

        <!-- Filtros -->
        <div class="row g-3 mb-4">
          <div class="col-md-4">
            <label for="filterStation" class="form-label">
              Estação Meteorológica
            </label>
            <select
              id="filterStation"
              class="form-select form-select-sm"
              [(ngModel)]="selectedFilterStationId"
            >
              <option value="">Selecione uma estação</option>
              @for (station of stations; track station.id) {
                <option
                  [value]="station.id"
                  [attr.style]="getStationOptionStyle(station)"
                >
                  {{ getStationDisplayText(station) }}
                </option>
              }
            </select>
          </div>

          <div class="col-md-3">
            <label for="filterMonth" class="form-label"> Mês </label>
            <select
              id="filterMonth"
              class="form-select form-select-sm"
              [(ngModel)]="selectedFilterMonth"
            >
              <option value="">Selecione um mês</option>
              <option value="1">Janeiro</option>
              <option value="2">Fevereiro</option>
              <option value="3">Março</option>
              <option value="4">Abril</option>
              <option value="5">Maio</option>
              <option value="6">Junho</option>
              <option value="7">Julho</option>
              <option value="8">Agosto</option>
              <option value="9">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>
            </select>
          </div>

          <div class="col-md-3">
            <label for="filterYear" class="form-label"> Ano </label>
            <select
              id="filterYear"
              class="form-select form-select-sm"
              [(ngModel)]="selectedFilterYear"
            >
              <option value="">Selecione um ano</option>
              @for (year of availableYears; track year) {
                <option [value]="year">
                  {{ year }}
                </option>
              }
            </select>
          </div>

          <div class="col-md-2 d-flex align-items-end">
            <app-action-button
              [iconClass]="'fas fa-search'"
              [variant]="'outline-primary'"
              [size]="'sm'"
              [label]="'Buscar'"
              [title]="'Buscar dados meteorológicos'"
              [cssClass]="'w-100'"
              (clicked)="applyCustomFilter()"
            >
            </app-action-button>
          </div>
        </div>

        <!-- Cards dos Dados Filtrados -->
        @if (showFilteredResults) {
          <div class="row g-2 mb-3">
            <!-- Card 1 - Média histórica de temperatura (Filtrado) -->
            <div class="col-md-3">
              <app-dashboard-metric-card
                [titleCard]="
                  'Temperatura média (histórico) - ' +
                  selectedFilterMonthNameAbbr +
                  '.'
                "
                [value]="filteredAvgHistoricalTemp"
                [type]="filteredAvgHistoricalTempType"
                [isLoading]="isLoadingFiltered"
              >
              </app-dashboard-metric-card>
            </div>

            <!-- Card 2 - Média de chuva acumulada (Filtrado) -->
            <div class="col-md-3">
              <app-dashboard-metric-card
                [titleCard]="
                  'Chuva acumulada (histórico) - ' +
                  selectedFilterMonthNameAbbr +
                  '.'
                "
                [value]="filteredAvgAccumulatedRain"
                [type]="filteredAvgAccumulatedRainType"
                [isLoading]="isLoadingFiltered"
              >
              </app-dashboard-metric-card>
            </div>

            <!-- Card 3 - Temperatura média (Filtrado) -->
            <div class="col-md-3">
              <app-dashboard-metric-card
                [titleCard]="
                  'Temperatura média - ' +
                  selectedFilterMonthNameAbbr +
                  '. ' +
                  selectedFilterYear
                "
                [value]="filteredAvgTemp"
                [type]="filteredAvgTempType"
                [isLoading]="isLoadingFiltered"
              >
              </app-dashboard-metric-card>
            </div>

            <!-- Card 4 - Chuva acumulada (Filtrado) -->
            <div class="col-md-3">
              <app-dashboard-metric-card
                [titleCard]="
                  'Chuva acumulada - ' +
                  selectedFilterMonthNameAbbr +
                  '. ' +
                  selectedFilterYear
                "
                [value]="filteredAccumulatedRain"
                [type]="filteredAccumulatedRainType"
                [isLoading]="isLoadingFiltered"
              >
              </app-dashboard-metric-card>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
